export const bgColors = [
  "rgb(161, 71, 71)",
  "rgb(175, 101, 57)",
  "rgb(161, 145, 50)",
  "rgb(85, 161, 62)",
  "rgb(51, 165, 117)",
  "rgb(71, 87, 161)",
  "rgb(102, 71, 161)",
  "rgb(161, 71, 141)",
];
